export default __webpack_public_path__ + "static/media/quiz_out.b3160216.png";